import React from 'react'
import HeroBanner from '../../components/User/common/HeroBanner'
import IndustriesPage from '../../components/User/Industries/IndustriesPage'

const Industries = () => {
  return (
    <div>
        <HeroBanner subheading='Home / Our Industries'/>
        <IndustriesPage/>
    </div>
  )
}

export default Industries